import type { SignedDocument } from 'store/types';

export function checkIfSameDocument(
  signedDocument: SignedDocument,
  selectedCurrentSignedDocuments: SignedDocument
): boolean {
  return (
    signedDocument.envelopeDocumentId === selectedCurrentSignedDocuments.envelopeDocumentId &&
    signedDocument.uploadedDocumentId === selectedCurrentSignedDocuments.uploadedDocumentId &&
    signedDocument.externalType === selectedCurrentSignedDocuments.externalType &&
    signedDocument.externalEnvelopeId === selectedCurrentSignedDocuments.externalEnvelopeId &&
    signedDocument.externalDocumentId === selectedCurrentSignedDocuments.externalDocumentId
  );
}
